import { useEffect } from "react";
import { getThemeConfig } from "./themeService";

import fallbackLandingPageIcon from "../../assets/icons/platform-landing-logo.png";
import fallbackSmallSideLogo from "../../assets/icons/askelie-logo.PNG";
import fallbackLargeSideLogo from "../../assets/icons/askelie-sideheader.png";

const DEFAULT_BRAND_NAME = "AskElie";

export default function useBrandingAssets({ pageTitle } = {}) {
  const branding = getThemeConfig();
  const brandName = branding?.brandName ?? DEFAULT_BRAND_NAME;

  useEffect(() => {
    if (pageTitle) {
      document.title = `${brandName} | ${pageTitle}`;
    }
  }, [brandName, pageTitle]);

  return {
    brandName,
    landingPageIcon: branding?.landingPageIcon ?? fallbackLandingPageIcon,
    smallSideLogo: branding?.smallSideLogo ?? fallbackSmallSideLogo,
    largeSideLogo: branding?.largeSideLogo ?? fallbackLargeSideLogo,
  };
}
